import React from "react"
import PropTypes from "prop-types"
import MapBrowser from "../map/MapBrowser"
import API from "../API"
import I from "./Initialize"
import Select from 'react-select';
import { ListGroup, Button, Form } from 'react-bootstrap'
import { Card, CardHeader, CardBody } from 'reactstrap';
import DeviceList from '../device_list/DeviceList'
import SidebarDeviceList from '../device_list/SidebarDeviceList'
import { mapType } from '../map/MapBrowser'
import EmergencyNotice from './EmergencyNotice'
import { initializeWebsocket, cleanWebsocket } from './Websocket.js';
import DelayControll from './delay_controll';

var this_obj;
let listChange = 0;

//ウインドウサイズの取得
function getWindowSize() {
  const w = window;
  const d = document;
  const e = d.documentElement;
  const g = d.getElementsByTagName('body')[0];
  const width = w.innerWidth || e.clientWidth || g.clientWidth;
  const height = w.innerHeight || e.clientHeight || g.clientHeight;
  return {
    width: width,
    height: height
  }
}
export default class GeofenceForm extends React.Component {

  constructor(props) {
    super(props);
    let original = I.initialize(this.props.deviceMap)

    //Display Size
    const w = getWindowSize();
    let mobile = false;
    let ipad = false;
    if (w.width < 500) {
      mobile = true;
    } else if (w.width < 1100) {
      ipad = true;
    } else {
    }

    //Initialize device group visible
    let deviceGroups = [];
    let noGroup = { id: -1, group_name: "No Group", visible: true, count: this.props.deviceGroupsCount[""] };
    deviceGroups.push(noGroup);
    for (let i in this.props.deviceGroups) {
      let dg = this.props.deviceGroups[i];
      dg.visible = true;

      if (this.props.deviceGroupsCount[dg.id]) {
        dg.count = this.props.deviceGroupsCount[dg.id];
      } else {
        dg.count = 0;
      }
      deviceGroups.push(dg);
    }

    this.state = {
      deviceMap: original,
      originalMap: original,
      show_label: true,
      show_line: false,
      knot: false,
      max_line_length: 30,
      measure_distance: false,
      deviceGroups: deviceGroups,
      mapType: mapType.osmBlackAndWhite,
      online: false,
      emergencies: [],//this.props.emergencies,
      emergencies_count: this.props.emergencies.length,
      tracks: [],
      track: false,
      notice: false,
      is_mobile: mobile,
      trackingDeviceId: null,
      autoTrackDone: false, // auto_track=1 の自動追跡が完了したかどうか
    }
    this_obj = this;
    this.MapBrowserRef = React.createRef();
    this.checkDevicesInfo = this.checkDevicesInfo.bind(this);
    this.deviceMove = this.deviceMove.bind(this);
    this.checkDevicesStatus = this.checkDevicesStatus.bind(this);
    this.handleShowLabel = this.handleShowLabel.bind(this);
    this.handleShowLine = this.handleShowLine.bind(this);
    this.handleChangeKnot = this.handleChangeKnot.bind(this);
    this.handleMeasureDistance = this.handleMeasureDistance.bind(this);
    this.handleUpdateDeviceMap = this.handleUpdateDeviceMap.bind(this);
    this.toggleMeasureDistance = this.toggleMeasureDistance.bind(this);
    this.setMapType = this.setMapType.bind(this);
    this.cleanup = this.cleanup.bind(this);
    this.handleTrackDevice = this.handleTrackDevice.bind(this);
    this.intervalIdDeviceInfo = null;
    this.intervalIdDeviceStatus = null;
    this.intervalIdDeviceMove = null;
    this.intervalEmergencies = null;
  }

  componentDidMount() {
    const isHiddenOffline =
      this.props.url_params?.hidden_offline === "true" ? true : false;

    initializeWebsocket(this.state.deviceMap, this, this.props.map_ws_endpoint, this.props.organization_id, this.props.authenticity_token, isHiddenOffline);
    this.checkDevicesInfo();
    //this.checkDevicesStatus();
    this.deviceMove();
    this.checkEmergencies();

    // railsによるMPAの場合、ページ遷移時にcomponentWillUnmountが呼ばれないので、
    // turbolinks:before-visitイベントでクリーンアップするようにした。
    // その他の解決策: SPAにする、関数コンポーネントにしてuseEffectを使うなど。
    document.addEventListener("turbolinks:before-visit", this.cleanup);

  }

  componentWillUnmount() {
    this.cleanup();
  }

  // auto_track=1: GPS受信中の最初のデバイスを自動追跡
  componentDidUpdate() {
    if (this.state.autoTrackDone) return;

    const urlParams = new URLSearchParams(window.location.search);
    const autoTrack = this.props.url_params?.auto_track === "1"
      || urlParams.get("auto_track") === "1";
    if (!autoTrack) return;

    // GPS受信中のデバイスを探す
    const gpsDevice = this.state.deviceMap.find(d => {
      const isOnline = d.status === 'ONLINE';
      const isNosignal = d.emergency_reason && d.emergency_reason.includes('NOSIGNAL');
      return isOnline && !isNosignal && d.fix === 1;
    });

    if (gpsDevice) {
      this.setState({ autoTrackDone: true });
      this.handleTrackDevice(gpsDevice.deviceId);
    }
  }

  cleanup() {
    cleanWebsocket();
    clearInterval(this.intervalIdDeviceInfo);
    clearInterval(this.intervalIdDeviceStatus);
    clearInterval(this.intervalIdDeviceMove);
    clearInterval(this.intervalEmergencies);
    document.removeEventListener("turbolinks:before-visit", this.cleanup);
  }

  //デバイスを動かす
  setDevices(devices) {
    this_obj.setState({ deviceMap: devices.slice() });
  }

  //デバイスを動かす
  deviceMove() {
    this.intervalIdDeviceMove = setInterval(() => {
      this.setState({ deviceMap: this.state.deviceMap.slice() });
    }, 1000);
  }


  //デバイスの状態（API経由でlastGPSとlastAccessを取得）
  checkDevicesInfo() {
    let onSuccess = (res) => {
      try {
        let devices_info = res.data.devices;
        if (!devices_info) return; // APIレスポンスが想定外の場合はスキップ
        let deviceMap = this.state.deviceMap;
        for (let i in deviceMap) {
          if (devices_info[deviceMap[i].deviceId]) {
            let d = devices_info[deviceMap[i].deviceId];
            let lastgps = new Date(Date.parse(d.lastGPS));
            let lastaccess = new Date(Date.parse(d.lastAccess));
            // 時刻文字列を生成（HH:MM:SS形式）
            let pad = (n) => String(n).padStart(2, '0');
            let lastgps_str = pad(lastgps.getHours()) + ":" + pad(lastgps.getMinutes()) + ":" + pad(lastgps.getSeconds());
            let lastaccess_str = pad(lastaccess.getHours()) + ":" + pad(lastaccess.getMinutes()) + ":" + pad(lastaccess.getSeconds());
            // ステータス情報をデバイスに保存
            deviceMap[i].status = "ONLINE";
            deviceMap[i].lastGPS = lastgps_str;
            deviceMap[i].lastAccess = lastaccess_str;
            // GPS受信判定: lastGPSとlastAccessが一致 → GPS受信中
            deviceMap[i].fix = (lastaccess_str === lastgps_str) ? 1 : 0;
          }
          else {
            deviceMap[i].status = "";
            deviceMap[i].lastGPS = null;
            deviceMap[i].lastAccess = null;
            deviceMap[i].fix = 0;
          }
        }
        this.setState({ deviceMap: deviceMap.slice() });
      } catch (e) {
        console.log("checkDevicesInfo error:", e);
      }
    }
    //デバイスステータスを取得
    API.getDeviceInfo({ onSuccess: onSuccess, organization_id: this.props.organization_id })
    this.intervalIdDeviceInfo = setInterval(() => {
      API.getDeviceInfo({ onSuccess: onSuccess, organization_id: this.props.organization_id })
    }, 10000);
  }

  //デバイスの状態
  checkDevicesStatus() {
    let onSuccess = (res) => {
      let device_statuses = res.data;

      let device;
      let deviceMap = this_obj.state.deviceMap;
      for (let i in deviceMap) {
        for (let j in device_statuses) {
          if (deviceMap[i].deviceId == device_statuses[j].serial) {
            //デバイスのプロパティをアップデート
            device = deviceMap[i]
            device.geofence = device_statuses[j].geofence_name;
            device.searchstr = device.ori_searchstr + device.geofence;
            if (device.status)
              device.searchstr = device.searchstr + "ONLINE";
            device.emergency = device_statuses[j].emergency;
            device.emergency_signaled_at = device_statuses[j].emergency_signaled_at;
            break;
          }
        }
      }

      // Statusの値を持つDeviceを前にソートする
      let sorted_deviceMap = [];
      let n_gps_device = 0;
      for (let i in deviceMap) {
        let device = deviceMap[i];
        if (device.status) {
          sorted_deviceMap.splice(n_gps_device, 0, device);
          n_gps_device++;
        } else {
          sorted_deviceMap.push(device);
        }
      }

      // DeviceMapのidの順番を比較して、変化があった場合listChangeをインクリメント
      let pre_idList = deviceMap.map(function (item) {
        return item.id;
      });
      let new_idList = sorted_deviceMap.map(function (item) {
        return item.id;
      });

      if (pre_idList.toString() != new_idList.toString()) {
        listChange++;
      }
      // ソートした配列をdeviceMapに代入
      deviceMap = sorted_deviceMap;

      //device setStateをアップデート
      this_obj.setState({
        deviceMap: deviceMap
      });
    }
    //デバイスステータスを取得
    API.getDeviceStatus({ organization_id: this.props.organization_id, onSuccess: onSuccess })
    this.intervalIdDeviceStatus = setInterval(() => {
      API.getDeviceStatus({ organization_id: this.props.organization_id, onSuccess: onSuccess })
    }, 5000);
  }

  //緊急情報の取得
  checkEmergencies() {
    let onSuccess = (res) => {

      if (res.data.emergencies.length > this.state.emergencies_count) {
        alert("新たな緊急通報者がいます！")
        this.setState({
          notice: false,
          emergencies: res.data.emergencies,
          emergencies_count: res.data.emergencies.length
        });
        return;
      }
      if (res.data.emergencies.length > 0) {
        this.setState({
          notice: true,
          emergencies: res.data.emergencies,
          emergencies_count: res.data.emergencies.length
        });
      } else {
        this.setState({
          notice: false,
          emergencies: res.data.emergencies,
          emergencies_count: res.data.emergencies.length
        });
      }
      //Tracks
      if (res.data.tracks.length > 0) {
        this.setState({
          track: true,
          tracks: res.data.tracks,
        });
      }
    }
    let onError = (res) => {
      console.log("--API.getEmergencies err--", res.data)
    }
    //デバイスステータスを取得
    this.intervalEmergencies = setInterval(() => {
      API.getEmergencies({ onSuccess: onSuccess, onError: onError, organization_id: this.props.organization_id, authenticity_token: this.props.authenticity_token })
    }, 3000);
    return () => clearInterval(this.intervalEmergencies)
  }


  handleShowLabel() {
    this.setState({
      show_label: !this.state.show_label,
    });
  }

  handleShowLine() {
    this.setState({
      show_line: !this.state.show_line,
    });
  }

  handleChangeKnot() {
    this.setState({
      knot: !this.state.knot,
    });
  }

  handleMeasureDistance() {
    this.toggleMeasureDistance();
    this.MapBrowserRef.current.initShowDistanceDevices();
  }

  toggleMeasureDistance() {
    this.setState({
      measure_distance: !this.state.measure_distance,
    });
  }

  //子コンポーネントから呼び出される更新関数
  handleUpdateDeviceMap(newDeviceGroups, newMap) {
    this.setState({
      deviceGroups: newDeviceGroups,
      deviceMap: newMap,
    });
  }

  //子コンポーネントから呼び出される更新関数（max_line_length)
  handleChangeMaxLength(val) {
    this_obj.setState({
      max_line_length: val,
    })
  }

  setMapType(type) {
    localStorage.setItem('map_type', type);
    this.setState({
      mapType: type,
    });
  }

  // デバイス追跡: チェックされたデバイスを地図中央に表示 + 青い丸で囲む
  handleTrackDevice(deviceId) {
    const isDeselect = this.state.trackingDeviceId === deviceId;
    const newTrackingId = isDeselect ? null : deviceId;

    // deviceMapの各デバイスのischeckedを更新
    let deviceMap = this.state.deviceMap;
    for (let i in deviceMap) {
      if (deviceMap[i].deviceId === deviceId) {
        deviceMap[i].ischecked = !isDeselect; // 追跡ON→true, 追跡OFF→false
      } else {
        deviceMap[i].ischecked = false; // 他のデバイスは解除
      }
    }

    this.setState({
      trackingDeviceId: newTrackingId,
      deviceMap: deviceMap.slice(),
    });
  }


  render() {

    const { deviceMap, originalMap } = this.state;
    // listChangeが変化するとDeviceListは強制的に更新される
    const deviceList = <DeviceList deviceMap={deviceMap}
      originalMap={originalMap}
      deviceGroups={this.state.deviceGroups}
      handleUpdateDeviceMap={this.handleUpdateDeviceMap}
      key={listChange}
      handleShowLabel={this.handleShowLabel}
      handleShowLine={this.handleShowLine}
      show_label={this.state.show_label}
      show_line={this.state.show_line}
      knot={this.state.knot}
      handleChangeKnot={this.handleChangeKnot}
      measure_distance={this.state.measure_distance}
      max_line_length={this.state.max_line_length}
      handleChangeMaxLength={this.handleChangeMaxLength}
      handleMeasureDistance={this.handleMeasureDistance}
      toggleMeasureDistance={this.toggleMeasureDistance}
      setMapType={this.setMapType}
      mapboxOption={this.props.mapboxOption}
    />

    const mapHeight = this.props.is_public_map ? '95vh' : this.state.is_mobile ? '70vh' : '87vh';

    // 追跡中デバイスの位置を取得
    let focusPosition = null;
    if (this.state.trackingDeviceId !== null) {
      const trackedDevice = this.state.deviceMap.find(d => d.deviceId === this.state.trackingDeviceId);
      if (trackedDevice && trackedDevice.pos && trackedDevice.pos[0] > 0) {
        focusPosition = trackedDevice.pos;
      }
    }

    // no_sidebar=1: サイドバーなしの従来レイアウト（全画面地図）
    const urlSearchParams = new URLSearchParams(window.location.search);
    const noSidebar = this.props.url_params?.no_sidebar === "1"
      || urlSearchParams.get("no_sidebar") === "1";

    if (noSidebar) {
      return (
        <>
          <EmergencyNotice notice={this.state.notice} track={this.state.track} />
          <MapBrowser ref={this.MapBrowserRef}
            center={this.props.center} zoom={this.props.zoom} height={'100vh'}
            lines={this.props.lines}
            circles={this.props.circles}
            polygons={this.props.polygons}
            vbuoys={this.props.vbuoys}
            geojsons={this.props.geojsons}
            emergencies={[...this.state.emergencies, ...this.state.tracks]}
            deviceMap={this.state.deviceMap}
            showPins={false}
            topright={deviceList}
            show_label={this.state.show_label}
            show_line={this.state.show_line}
            max_line_length={this.state.max_line_length}
            measure_distance={this.state.measure_distance}
            mapType={this.state.mapType}
            setMapType={this.setMapType}
            online={this.state.online}
            knot={this.state.knot}
            focusPosition={focusPosition}
            mapboxOption={this.props.mapboxOption}
            mapboxAccessToken={this.props.mapboxAccessToken}
          />
        </>
      );
    }

    // 公開Map: サイドバー + 地図レイアウト（ヘッダーなし）
    if (this.props.is_public_map) {
      // モバイル: 地図（上部60%）+ リスト（下部）
      if (this.state.is_mobile) {
        return (
          <>
            <EmergencyNotice notice={this.state.notice} track={this.state.track} />
            <div className="home-mobile-layout" style={{ height: '100vh' }}>
              <div className="home-mobile-map">
                <MapBrowser ref={this.MapBrowserRef}
                  center={this.props.center} zoom={this.props.zoom} height="100%"
                  lines={this.props.lines}
                  circles={this.props.circles}
                  polygons={this.props.polygons}
                  vbuoys={this.props.vbuoys}
                  geojsons={this.props.geojsons}
                  emergencies={[...this.state.emergencies, ...this.state.tracks]}
                  deviceMap={this.state.deviceMap}
                  showPins={false}
                  topright={deviceList}
                  show_label={this.state.show_label}
                  show_line={this.state.show_line}
                  max_line_length={this.state.max_line_length}
                  measure_distance={this.state.measure_distance}
                  mapType={this.state.mapType}
                  setMapType={this.setMapType}
                  online={this.state.online}
                  knot={this.state.knot}
                  focusPosition={focusPosition}
                  mapboxOption={this.props.mapboxOption}
                  mapboxAccessToken={this.props.mapboxAccessToken}
                />
              </div>
              <div className="home-mobile-list">
                <SidebarDeviceList
                  deviceMap={this.state.deviceMap}
                  trackingDeviceId={this.state.trackingDeviceId}
                  onTrackDevice={this.handleTrackDevice}
                  organizationId={this.props.organization_id}
                  showEditLink={false}
                />
              </div>
            </div>
          </>
        );
      }
      // デスクトップ: サイドバー + 地図
      return (
        <>
          <EmergencyNotice notice={this.state.notice} track={this.state.track} />
          <div className="home-layout" style={{ height: '100vh' }}>
            <div className="home-sidebar" style={{ height: '100vh' }}>
              <SidebarDeviceList
                deviceMap={this.state.deviceMap}
                trackingDeviceId={this.state.trackingDeviceId}
                onTrackDevice={this.handleTrackDevice}
                organizationId={this.props.organization_id}
                showEditLink={false}
              />
            </div>
            <div className="home-map-area">
              <MapBrowser ref={this.MapBrowserRef}
                center={this.props.center} zoom={this.props.zoom} height="100vh"
                lines={this.props.lines}
                circles={this.props.circles}
                polygons={this.props.polygons}
                vbuoys={this.props.vbuoys}
                geojsons={this.props.geojsons}
                emergencies={[...this.state.emergencies, ...this.state.tracks]}
                deviceMap={this.state.deviceMap}
                showPins={false}
                topright={deviceList}
                show_label={this.state.show_label}
                show_line={this.state.show_line}
                max_line_length={this.state.max_line_length}
                measure_distance={this.state.measure_distance}
                mapType={this.state.mapType}
                setMapType={this.setMapType}
                online={this.state.online}
                knot={this.state.knot}
                focusPosition={focusPosition}
                mapboxOption={this.props.mapboxOption}
                mapboxAccessToken={this.props.mapboxAccessToken}
              />
            </div>
          </div>
        </>
      );
    }

    // モバイル: 地図（上部60%）+ デバイスリスト（下部）の縦並びレイアウト
    if (this.state.is_mobile) {
      return (
        <>
          <EmergencyNotice notice={this.state.notice} track={this.state.track} />
          <div className="home-mobile-layout">
            <div className="home-mobile-map">
              <MapBrowser ref={this.MapBrowserRef}
                center={this.props.center} zoom={this.props.zoom} height="100%"
                lines={this.props.lines}
                circles={this.props.circles}
                polygons={this.props.polygons}
                vbuoys={this.props.vbuoys}
                geojsons={this.props.geojsons}
                emergencies={[...this.state.emergencies, ...this.state.tracks]}
                deviceMap={this.state.deviceMap}
                showPins={false}
                topright={deviceList}
                show_label={this.state.show_label}
                show_line={this.state.show_line}
                max_line_length={this.state.max_line_length}
                measure_distance={this.state.measure_distance}
                mapType={this.state.mapType}
                setMapType={this.setMapType}
                online={this.state.online}
                knot={this.state.knot}
                focusPosition={focusPosition}
                mapboxOption={this.props.mapboxOption}
                mapboxAccessToken={this.props.mapboxAccessToken}
              />
            </div>
            <div className="home-mobile-list">
              <SidebarDeviceList
                deviceMap={this.state.deviceMap}
                trackingDeviceId={this.state.trackingDeviceId}
                onTrackDevice={this.handleTrackDevice}
                organizationId={this.props.organization_id}
              />
            </div>
          </div>
          <DelayControll is_mobile={this.state.is_mobile} devices={this.state.deviceMap} setDevices={this.setDevices} />
        </>
      );
    }

    // デスクトップ: 3:9レイアウト（左サイドバー + 右地図）
    // ※ noSidebar / is_public_map の場合は上のifブランチで既にreturnされている
    return (
      <>
        <EmergencyNotice notice={this.state.notice} track={this.state.track} />
        <div className="home-layout" style={{ height: mapHeight }}>
          <div className="home-sidebar">
            <SidebarDeviceList
              deviceMap={this.state.deviceMap}
              trackingDeviceId={this.state.trackingDeviceId}
              onTrackDevice={this.handleTrackDevice}
              organizationId={this.props.organization_id}
            />
          </div>
          <div className="home-map-area">
            <MapBrowser ref={this.MapBrowserRef}
              center={this.props.center} zoom={this.props.zoom} height="100%"
              lines={this.props.lines}
              circles={this.props.circles}
              polygons={this.props.polygons}
              vbuoys={this.props.vbuoys}
              geojsons={this.props.geojsons}
              emergencies={[...this.state.emergencies, ...this.state.tracks]}
              deviceMap={this.state.deviceMap}
              showPins={false}
              topright={deviceList}
              show_label={this.state.show_label}
              show_line={this.state.show_line}
              max_line_length={this.state.max_line_length}
              measure_distance={this.state.measure_distance}
              mapType={this.state.mapType}
              setMapType={this.setMapType}
              online={this.state.online}
              knot={this.state.knot}
              focusPosition={focusPosition}
              mapboxOption={this.props.mapboxOption}
              mapboxAccessToken={this.props.mapboxAccessToken}
            />
          </div>
        </div>
        {!this.props.is_public_map &&
          <DelayControll is_mobile={this.state.is_mobile} devices={this.state.deviceMap} setDevices={this.setDevices} />
        }
      </>
    );
  }
}

